import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardProperty
} from "@flexinet/ui-components";
import {useAllowedItems} from "../../../hooks/useAllowedProperties.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {ProductLineItem} from "../types.ts";
import {CreatedByProfileFormatter} from "../../../components/CreatedByProfileFormatter.tsx";


export const Profile = ({record}: { record: ProductLineItem }) => {


    const properties = [
        {
            label: 'Product Name',
            value: record.product ? record.product.name : record.productId,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        }, {
            label: 'Product Feature Name',
            value: record.productFeature ? record.productFeature.name : record.productFeatureId,
            span: 12,
        }, {
            label: 'Position',
            value: record.position,
            span: 12,
        }, {
            label: 'Created By',
            value: <CreatedByProfileFormatter record={record as any}/>,
            rbac: rbacActions.UpdateProductLineItem,
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }] as PlatformPropertyCardProperty[];


    const {filterAllowed} = useAllowedItems()
    const allowedProperties = filterAllowed(properties) as PlatformPropertyCardProperty[];

    return (
        <PlatformPropertyCard properties={allowedProperties}/>
    );


};
